var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { useContext } from "react";
import { createEntityDefaultLayout } from "../entities/entity-default-layout";
import { defaultEntityLayouts, EntityLayoutsContext } from "../context/entity-layouts-context";
import { PageRenderer } from "../entities/page-renderer";
export var useEntityLayout = function (entityTypeName) {
  var contextLayouts = useContext(EntityLayoutsContext) || {};
  // We do not allow the Page entity to be completely overridable.
  // This is because the layout used for a page is variable, and the mechanism to 
  // render the correct page would be broken when overriding. The PageRenderer also renders slices too.
  var layouts = __assign(__assign(__assign({}, defaultEntityLayouts), contextLayouts), {
    Page: PageRenderer
  });
  // this could actually return an HOC which checks for the existence of an entity and 404s if it's not found too.
  return layouts[entityTypeName] || createEntityDefaultLayout(entityTypeName);
};